import { Link, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'lucide-react';

/**
 * Top-bar breadcrumb derived from the URL (spec §6.3). The first crumb
 * is always the workspace; the second is the section (Inbox, Vendors,
 * etc.) translated via the same appNav keys the sidebar uses.
 */
export function HeaderBreadcrumb() {
  const { t } = useTranslation();
  const { wsId } = useParams<{ wsId: string }>();
  const loc = useLocation();
  const segments = loc.pathname.split('/').filter(Boolean);

  // /app/workspace/:wsId/<section>(/...)
  const section = segments.length >= 4 ? segments[3] : null;

  // Map URL segments to the i18n keys used by AppShell.NAV.
  const NAV_KEY: Record<string, string> = {
    'inbox': 'inbox',
    'ap-invoices': 'ap',
    'ar-invoices': 'ar',
    'expenses': 'expenses',
    'cards': 'cards',
    'payments': 'payments',
    'approvals': 'approvals',
    'vendors': 'vendors',
    'closing': 'closing',
    'close-packet': 'closing',
    'ledger': 'ledger',
    'reports': 'reports',
    'agents': 'agents',
    'peppol': 'peppol',
    'bank-feed': 'bankFeed',
    'digital-records': 'digitalRecords',
    'audit': 'audit',
    'settings': 'settings',
  };
  const sectionKey = section ? NAV_KEY[section] : null;

  if (!wsId) return null;

  return (
    <nav aria-label="Breadcrumb" className="flex items-center text-sm min-w-0">
      <Link
        to={`/app/workspace/${wsId}/inbox`}
        className="text-ink-500 hover:text-ink-900 dark:hover:text-ink-100 truncate max-w-[160px]"
      >
        {t('topbar.workspace')}
      </Link>
      {sectionKey ? (
        <>
          <ChevronRight size={12} className="text-ink-300 mx-1.5 shrink-0" aria-hidden />
          <span className="text-ink-900 dark:text-ink-100 truncate">
            {t(`appNav.${sectionKey}`)}
          </span>
        </>
      ) : null}
    </nav>
  );
}
